<template>
  <div class="signup-layout">
    <SignupLeft />
    <div class="signup-layout__right">
      <div class="signup-layout__right__top-row">
        <template v-if="$route.name==='Signup'||$route.name==='Login'||$route.name==='Verify OTP'">
          <router-link v-if="$route.name==='Signup'" :to="{name:'Login'}">
            <button class="signup-layout__right__top-row__login-button">Log In</button>
          </router-link>
          <router-link
            v-else-if="$route.name==='Login'||$route.name==='Verify OTP'"
            :to="{name:'Signup'}"
          >
            <button class="signup-layout__right__top-row__back">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--gray-1)"
                stroke-width="2"
                stroke-linecap="square"
                stroke-linejoin="arcs"
              >
                <path d="M19 12H6M12 5l-7 7 7 7" />
              </svg>
            </button>
          </router-link>
        </template>
      </div>
      <div class="signup-layout__right__center">
        <slot />
      </div>
      <div class="signup-layout__right__bottom">
        <SignupGoogleTncMessage />
      </div>
    </div>
  </div>
</template>
<script>
import SignupLeft from "../components/SignupLeft";
import SignupGoogleTncMessage from "../components/SignupGoogleTncMessage";

export default {
  components: { SignupLeft, SignupGoogleTncMessage },
  mounted() {
    // console.log(this.$route);
  }
};
</script>
<style lang="scss" scoped>
.signup-layout {
  @media only screen and (min-width: 640px) {
    display: grid;
    grid-template-columns: 2fr 3fr;
    min-height: 100vh;
  }
  &__right {
    padding: 0 2rem;
    display: grid;
    position: relative;
    @media only screen and (min-width: 991px) {
      padding-left: 13rem;
      padding-right: 13rem;
      padding-bottom: 4rem;
      padding-top: 0;
    }
    @media only screen and (min-width: 640px) {
      display: grid;
      grid-template-rows: auto 1fr auto;
    }
    &__top-row {
      display: none;
      @media only screen and (min-width: 640px) {
        display: block;
        height: 3rem;
        &__back {
          position: absolute;
          top: 5rem;
          left: 5rem;
          background: transparent;
          border: none;
          svg {
            height: 2.7rem;
          }
        }
        &__login-button {
          background: transparent;
          border: 1px solid var(--primary-color);
          position: absolute;
          top: 5rem;
          right: 5rem;
          border-radius: 0.4rem;
          padding: 0.5rem 1rem;
        }
      }
    }
    &__center {
      align-self: center;
      display: grid;
    }
    &__bottom {
      align-self: end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Signup.vue